import * as Sentry from "@sentry/react";
import { logout } from "store/userSlice";
import { clearCookie, isUserCookie } from "./cookie";

async function doLogout(dispatch, reason = null, redirect = true, redirect_link = '/login', skipAutologin = true) {
  if (isUserCookie()) {
    await dispatch(logout(reason));
    clearCookie();
  }
  Sentry.setUser(null);
  Sentry.setContext('tenant', null);
  localStorage.removeItem('module');
  localStorage.removeItem('mode_scope');
  localStorage.removeItem('period');
  if (redirect) {
    const finalLink = redirect_link === '/login' && skipAutologin ? '/login?skip_autologin=1' : redirect_link;
    window.location.href = finalLink;
  }
}

export { doLogout };
